{
  "title": "Operations Inbox",
  "tabTitles": {
    "urgent": "🔴 ({{count}}) Operations Inbox",
    "actionable": "({{count}}) Operations Inbox",
    "default": "Operations Inbox",
    "appDefault": "AirPlx"
  },
  "header": {
    "timeFilters": {
      "today": "Today",
      "tomorrow": "Tomorrow",
      "week": "This Week",
      "all": "All"
    },
    "statusLabels": {
      "allSetToday": "All set for today",
      "nothingTomorrow": "Nothing tomorrow",
      "clearForWeek": "Clear for the week",
      "allCaughtUp": "All caught up!",
      "arrivalsToday": "{{count}} arrival today",
      "arrivalsTomorrow": "{{count}} arrival tomorrow",
      "arrivalsWeek": "{{count}} arrival this week",
      "total": "{{count}} total"
    },
    "newTails": "{{count}} new",
    "searchPlaceholder": "Search tail, type, operator...",
    "refreshStatus": {
      "refreshing": "Refreshing...",
      "updated": "Updated {{timeAgo}}",
      "justNow": "just now",
      "secondsAgo": "{{count}}s ago",
      "minuteAgo": "1m ago",
      "minutesAgo": "{{count}}m ago"
    }
  },
  "groups": {
    "unknownAircraft": {
      "title": "NEW TAILS",
      "tooltip": "First-time visitors that need to be set up in your system. Match them to existing aircraft or create new entries."
    },
    "needsRouting": {
      "title": "ASSIGN PARKING",
      "tooltip": "Arrivals that need a parking assignment. Choose a hangar or ramp for each."
    },
    "snoozed": {
      "count": "Snoozed ({{count}})",
      "tooltip": "Items you've temporarily hidden. They'll reappear in your inbox when the snooze period ends.",
      "snoozedUntil": "Snoozed until {{date}}"
    }
  },
  "actionTypeGroup": {
    "urgencyLabels": {
      "now": "NOW",
      "today": "TODAY"
    },
    "itemCount": "{{count}} item (collapsed)",
    "noItems": "No items in this group"
  },
  "bulkActions": {
    "selected": "{{count}} selected",
    "breakdown": "({{quarantineCount}} unknown, {{tripCount}} trips)",
    "mapAllTo": "Map all to...",
    "snoozeAll": "Snooze all",
    "buttons": {
      "mapToAircraft": "Map to aircraft",
      "assignLocation": "Assign location"
    }
  },
  "assignDropdown": {
    "assignTo": "Assign to...",
    "searchPlaceholder": "Search...",
    "hangarsSection": "HANGARS",
    "rampsSection": "RAMPS",
    "tooSmall": "Too small",
    "noDimensions": "No dimensions",
    "noMatchingLocations": "No matching locations",
    "noLocationsAvailable": "No locations available",
    "dimensions": {
      "width": "{{width}}'W",
      "depth": "{{depth}}'D",
      "height": "{{height}}'H"
    }
  },
  "snooze": {
    "title": "Snooze until",
    "dateFormat": {
      "todayAt": "Today at {{time}}",
      "tomorrowAt": "Tomorrow at {{time}}"
    }
  },
  "messages": {
    "mapped": "Mapped {{tailNumber}} → {{aircraftName}}",
    "assigned": "Assigned {{tailNumber}} to {{locationName}}",
    "snoozed": "Snoozed {{tailNumber}}",
    "unsnoozed": "Unsnoozed {{tailNumber}}",
    "bulkSnoozed": "Snoozed {{count}} items",
    "bulkMapped": "Mapped {{count}} aircraft to {{aircraftName}}",
    "bulkMappedPartial": "Mapped {{successCount}}/{{totalCount}} ({{failCount}} failed)",
    "bulkAssignedHangar": "Assigned {{count}} trips to {{locationName}}",
    "bulkAssignedRamp": "Assigned {{count}} trips to {{locationName}}",
    "bulkAssignedHangarPartial": "Assigned {{successCount}}/{{totalCount}} trips (failed: {{sampleFails}}{{moreFails}})",
    "bulkAssignedRampPartial": "Assigned {{successCount}}/{{totalCount}} trips (failed: {{sampleFails}}{{moreFails}})",
    "bulkAssignedHangarFailed": "Failed to assign trips: {{sampleFails}}{{moreFails}}",
    "bulkAssignedRampFailed": "Failed to assign trips: {{sampleFails}}{{moreFails}}"
  },
  "errors": {
    "resolveFailed": "Failed to resolve {{tailNumber}}: {{error}}",
    "assignFailed": "Failed to assign: {{error}}",
    "snoozeFailed": "Failed to snooze: {{error}}",
    "unsnoozeFailed": "Failed to unsnooze: {{error}}",
    "bulkResolveFailed": "Bulk resolve failed: {{error}}",
    "unknownError": "Unknown error",
    "loadFailed": "Failed to load inbox: {{error}}"
  },
  "emptyStates": {
    "today": {
      "title": "All set for today!",
      "message": "No arrivals need parking assignments.",
      "laterThisWeek": "{{count}} arrivals later this week",
      "newTailsToSetup": "{{count}} new tails to set up",
      "previewThisWeek": "Preview This Week",
      "setupNewTails": "Set Up New Tails"
    },
    "tomorrow": {
      "title": "Nothing scheduled for tomorrow",
      "message": "Check back later or view all arrivals.",
      "viewAll": "View All"
    },
    "week": {
      "title": "Clear for the week",
      "message": "All arrivals have been assigned parking.",
      "setupNewTails": "Set Up {{count}} New Tails"
    },
    "all": {
      "title": "All caught up!",
      "message": "No items need your attention right now."
    }
  },
  "quarantineCard": {
    "noTypeHint": "No type hint",
    "buttons": {
      "matchTo": "Match to {{type}}",
      "findAircraft": "Find aircraft",
      "later": "Later"
    },
    "labels": {
      "searchAircraft": "Search aircraft..."
    },
    "tooltips": {
      "searchForType": "Search for \"{{type}}\" in aircraft database"
    }
  },
  "tripCard": {
    "buttons": {
      "later": "Later"
    },
    "tooltips": {
      "aircraftTooLarge": "Aircraft too large",
      "mostUsedLocation": "Most used location ({{count}} assignments)",
      "assignTo": "Assign to {{name}}",
      "moreLocations": "More locations"
    }
  }
}
